module.exports = __webpack_public_path__ + "static/media/img91.20e8d394.png";